import React, { FC } from 'react';
import s from './InfoButton.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { useUIContext } from '../../context/UIContext';
import { reportInfoClick } from '../../utils/bi';

export const InfoButton: FC<{ dataHook?: string }> = ({ dataHook }) => {
  const { t } = useTranslation();
  const { isInfoShown, setIsInfoShown } = useUIContext();

  const toggleInfoMode = (newValue: boolean) => {
    if (newValue) {
      reportInfoClick();
    }
    setIsInfoShown(newValue);
  };

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      data-hook={dataHook}
      className={s.infoText}
      tabIndex={0}
      onClick={() => toggleInfoMode(!isInfoShown)}
      onKeyDown={(e) => e.key === 'Enter' && toggleInfoMode(!isInfoShown)}
      role="dialog"
      href="#"
    >
      {t('template.viewer.read.more')}
    </a>
  );
};
